module.exports = __webpack_public_path__ + "img/home-s1-img1.f0631fd6.png";